import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { formatCurrency } from 'syf-js-utilities';
import { t } from '../../../translations/getTranslation';
import Icon from '../../../components/Icon';
import DisputesTransactionTypeIcon from '../DisputeTransactionTypeIcon/DisputesTransactionTypeIcon';
const DateContent = styled.div `
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.regular}px;

  @media ${query.greaterThanMedium} {
    flex: 0 0 85px;
    font-size: ${({ theme }) => theme.fontSizes.root}px;
  }
`;
const DescriptionContent = styled.div `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${({ theme }) => theme.fontSizes.regular}px;

  @media ${query.greaterThanMedium} {
    margin-top: 0;
    font-size: ${({ theme }) => theme.fontSizes.root}px;
  }
`;
const AmountContent = styled.div `
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  @media ${query.greaterThanMedium} {
    margin-right: ${({ theme }) => theme.spacing.small}px;
  }
`;
const ExpandIcon = styled(Icon) `
  color: ${({ theme }) => theme.colors.denimBlue};
`;
const IconContainer = styled.div `
  padding-right: ${({ theme }) => theme.spacing.large}px;

  @media ${query.greaterThanMedium} {
    padding-right: ${({ theme }) => theme.spacing.xlarge}px;
  }
`;
const TransactionContent = styled.div `
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;

  @media ${query.greaterThanMedium} {
    align-items: center;
  }
`;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall}px;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    gap: 0;
  }
`;
const DateDescriptionContainer = styled(Container) `
  width: 100%;
  overflow: hidden;
`;
const AmountContainer = styled(Container) `
  align-items: end;

  @media ${query.greaterThanMedium} {
    align-items: center;
  }
`;
const TransactionItem = ({ transaction, expand }) => {
    const { description, formattedDate, transactionAmount } = transaction;
    const formattedTransactionAmount = formatCurrency(transactionAmount);
    return (_jsxs(TransactionContent, { children: [_jsx(IconContainer, { children: _jsx(DisputesTransactionTypeIcon, { title: t('common.purchase'), type: "PURCHASE" }) }), _jsxs(DateDescriptionContainer, { children: [_jsx(DateContent, { children: formattedDate }), _jsx(DescriptionContent, { children: description })] }), _jsxs(AmountContainer, { children: [_jsx(AmountContent, { children: formattedTransactionAmount }), _jsx(ExpandIcon, { name: expand ? 'faChevronUp' : 'faChevronDown', size: "1x", "data-type": "replacement card", "data-reason": "more info", "data-object": "button", "data-analytics": "clicktrackingevent" })] })] }));
};
export default TransactionItem;
//# sourceMappingURL=index.js.map